module.exports = __webpack_public_path__ + "img/blueDownload.86998fc7.svg";